module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#listicle",
      toString: function () {
        return this.url;
      }
    }